const ABN_REGEX = new RegExp(/^(\d *?){1,11}$/)
const EIN_REGEX = new RegExp(/^(\d *?){1,9}$/)
const CRN_REGEX = new RegExp(/^(\d *?){1,8}$/)

export const prettyAbn = (abn?: string) => {
  if (!abn) {
    return
  }

  if (abn?.length > 11 || !ABN_REGEX.test(abn)) {
    return abn
  }

  const abnString = abn?.toString()
  const trimmedAbn = abnString?.replace(/\s+/g, '')
  const digits = trimmedAbn.split('')

  const pointsToSpace = [2, 5, 8]

  pointsToSpace.forEach((point, index) => {
    if (abn.length > point) {
      digits.splice(point + index, 0, ' ')
    }
  })

  return digits.join('')
}

export const prettyEin = (ein?: string) => {
  if (!ein) {
    return
  }

  if (ein?.length > 9 || !EIN_REGEX.test(ein)) {
    return ein
  }

  const trimmedEin = ein?.replace(/[-\s]+/g, '')
  const digits = trimmedEin.split('')

  // Add hyphen after first 2 digits
  if (ein.length > 2) {
    digits.splice(2, 0, '-')
  }

  return digits.join('')
}

export const prettyCrn = (crn?: string) => {
  if (!crn) {
    return
  }

  if (crn?.length > 8 || !CRN_REGEX.test(crn)) {
    return crn
  }

  const trimmedCrn = crn?.replace(/\s+/g, '')
  return trimmedCrn
}
